import React, { useEffect, useState } from "react";

import Container from "@material-ui/core/Container";
import Button from "@material-ui/core/Button";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ApplicationHeader from "../application/ApplicationHeader";
import ApplicationPanel from "../application/ApplicationPanel";

import {
  Redirect,
  Route,
  useHistory,
  useRouteMatch,
  useLocation,
} from "react-router-dom";
import withAuthorization from "../auth/withAuthorization";
import ModuleGroupsBrowser from "./ModuleGroupsBrowser";
import ModuleGroupEdit from "./edit/ModuleGroupEdit";

import { equals } from "ramda";

const AuthorizedRoute = withAuthorization(Route);

const ModuleGroupsView = () => {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  const [isHome, setIsHome] = useState(pathname);
  useEffect(() => {
    equals(pathname, "/manage-module-groups")
      ? setIsHome(true)
      : setIsHome(false);
  }, [pathname]);

  const history = useHistory();
  return (
    <Container id="manage-module-groups" disableGutters>
      <ApplicationHeader
        applicationNavigation={
          isHome ? (
            <div></div>
          ) : (
            <Button
              onClick={() => history.push(path)}
              startIcon={<ArrowBackIcon />}
            >
              Module Group Home
            </Button>
          )
        }
      />
      <AuthorizedRoute exact path={path} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel
          id="application-panel-module-groups"
          background="white"
        >
          <ModuleGroupsBrowser />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute exact path={`${path}/:id`} roles={["ROLE_ADMIN"]}>
        <ApplicationPanel
          id="application-panel-module-group-edit"
          background="white"
        >
          <ModuleGroupEdit onBack={() => history.push(path)} />
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route path={path} exact>
        <Redirect to={path} />
      </Route>
    </Container>
  );
};

export default ModuleGroupsView;
